import { Configuration } from "../types";

export const filterConfigurations = (configurations: Configuration[], searchQuery: string) => {
  const query = (searchQuery || "").toLowerCase();

  return configurations.filter((c) => {
    const name = (c?.conname || "").toLowerCase();
    const value = c?.convalue?.toString() || "";
    return name.includes(query) || value.includes(query);
  });
};

